import '@rmwc/menu/styles';
import {Menu as RMWCMenu} from '@rmwc/menu';
import type React from 'react';

const Menu = (
  props: React.ComponentPropsWithRef<typeof RMWCMenu>,
): React.JSX.Element => {
  const onMenuOpen = () => {
    setTimeout(() => {
      const focusedOption = document.querySelector(
        '.mdc-ripple-upgraded--background-focused',
      );
      if (focusedOption) {
        focusedOption.classList.remove(
          'mdc-ripple-upgraded--background-focused',
        );
      }
    }, 10);
  };

  let keydownPress = false;
  const handleKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === 'ArrowDown' && !keydownPress) {
      (e.target as HTMLElement).focus();
      (e.target as HTMLElement).classList.add(
        'mdc-ripple-upgraded--background-focused',
      );
      keydownPress = true;
    }
  };

  return (
    <RMWCMenu
      {...props}
      onOpen={onMenuOpen}
      onKeyDown={handleKeyDown}
    />
  );
};

export {Menu};
